// @flow
import React from "react";
import styled from "styled-components";
import { Field } from "react-final-form";
import Moment from "moment";

import { media, AddressPicker, DatePicker, Button, P } from "@nested/ui";
import { isInThePast } from "./utils";

const FormWrapper = styled.div`
  margin: 20px auto 0;
`;

const DateWrapper = styled.div`
  ${media.tablet`
    width: 50%;
    display: inline-block;
    padding-left: 10px;
  `};
`;

const AddressWrapper = styled.div`
  ${media.tablet`
    width: 50%;
    padding-right: 10px;
    display: inline-block;
  `}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ErrorMessage = styled(P)`
  color: ${({ theme }) => theme.palette.data.red};
`;

function ErrorComponent({ invalid, touched, error }) {
  return invalid && touched ? <ErrorMessage>{error}</ErrorMessage> : null;
}

// eslint-disable-next-line no-unused-vars
const required = (value, _) => (value ? undefined : "Required");
const notInThePast = (value, today) =>
  isInThePast(value, today) ? "This date is in the past" : undefined;

const composeValidators = (today, ...validators) => (value) =>
  validators.reduce(
    (error, validator) => error || validator(value, today),
    undefined,
  );

type Props = {
  submitError: any,
  today: Moment,
};

const FormComponent = ({ submitError, today }: Props) => (
  <FormWrapper>
    <AddressWrapper>
      <Field name="address" validate={required}>
        {({ input, meta }) => (
          <>
            <ErrorComponent {...meta} />
            <AddressPicker
              {...input}
              {...meta}
              label="What’s Your Address?"
              placeholder="Enter your postcode"
              onPostcodeNotInServicedArea={() => undefined}
              data-test="select-address"
            />
          </>
        )}
      </Field>
    </AddressWrapper>
    <DateWrapper>
      <Field
        name="moveDate"
        validate={composeValidators(today, required, notInThePast)}
      >
        {({ input, meta }) => (
          <>
            <ErrorComponent {...meta} />
            <DatePicker
              {...input}
              {...meta}
              label="When do you want to move?"
              placeholder="dd/mm/yyyy"
              viewMode="months"
              data-test="select-date"
              today={today}
            />
          </>
        )}
      </Field>
    </DateWrapper>
    {submitError && (
      <ErrorMessage data-test="submit-error-failure-message" center>
        {submitError}
      </ErrorMessage>
    )}
    <ButtonWrapper>
      <Button fullWidth colour="blue" inverted>
        Show my moving timeline
      </Button>
    </ButtonWrapper>
  </FormWrapper>
);

export default FormComponent;
